export const CUSTOMERS = "CUSTOMERS";
export const CUSTOMERS_SUCCESS = "CUSTOMERS_SUCCESS";
export const CUSTOMERS_FAIL = "CUSTOMERS_FAIL";
